// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldPathSelector_root__2nXqR","menu":"FieldPathSelector_menu__psUmo","fieldItemLabel":"FieldPathSelector_fieldItemLabel__2H_oZ"};